import {useCallback, useState} from 'react';
import produce, { enableES5 } from 'immer';

enableES5();

// 使用immer.js 改善 setState(Object) 的开发体验
const useImmerState = (initialValue:any) => {
  const [val, updateVal] = useState(initialValue);
  return [
    val,
    useCallback(updater => {
      updateVal(produce(updater));
    }, [])
  ];
}

export default useImmerState;